<div class="flex align-items-center gap-3">
  @if (quickLink) {
    <p-button
      size="small"
      class="flex"
      severity="secondary"
      icon="fas fa-cogs"
      [rounded]="true"
      [outlined]="true"
      [routerLink]="quickLink"
      [label]="quickLinkLabel || ''"></p-button>
  }
  @if (showAddButton && activeUserStore.canAccessEntityAdder()) {
    <p-button
      [disabled]="disableAddButton"
      size="small"
      [text]="true"
      [raised]="true"
      [rounded]="true"
      label="hinzufügen"
      severity="success"
      icon="fas fa-circle-plus"
      [routerLink]="addRoute"></p-button>
  }

  @if (showRangeFilter) {
    <p-calendar
      class="ml-auto w-10rem"
      [(ngModel)]="fromDate"
      [showIcon]="true"
      dateFormat="dd.mm.yy"
      placeholder="Von"
      (onSelect)="emitDateRange()"></p-calendar>
    <p-calendar
      class="w-10rem"
      [(ngModel)]="toDate"
      [showIcon]="true"
      dateFormat="dd.mm.yy"
      placeholder="Bis"
      (onSelect)="emitDateRange()"></p-calendar>
  }
  <div
    class="flex align-items-center"
    [ngClass]="{ 'ml-auto': !showRangeFilter, 'gap-3': showRangeFilter }">
    <ng-content select="[left]"></ng-content>
    <span class="p-input-icon-left">
      <i class="fas fa fa-magnifying-glass ml-1"></i>
      <input
        class="border-round-3xl"
        pInputText
        type="text"
        [(ngModel)]="searchWord"
        (input)="search.emit(getTarget($event.target).value)"
        placeholder="durchsuchen ..." />
    </span>
    <p-button
      size="small"
      [severity]="showRangeFilter ? 'primary' : 'secondary'"
      [style]="{ 'margin-left': showRangeFilter ? 0 : '-2.75rem' }"
      pTooltip="Alle Einträge anzeigen"
      [rounded]="true"
      [text]="!showRangeFilter"
      [outlined]="showRangeFilter"
      [icon]="
        showRangeFilter ? 'fas fa-filter-circle-xmark' : 'fas fa-circle-xmark'
      "
      [disabled]="
        (!searchWord && !showRangeFilter) ||
        (!searchWord && !fromDateChange && !toDateChange)
      "
      (click)="clear()"></p-button>
  </div>
</div>
